import { useEffect } from "react";

export const useRealtime = (onRides, onPresence) => {
  useEffect(() => {
    let ws;
    let timer;
    let ping;
    let stopped = false;
    let delay = 1000;
    const connect = () => {
      ws = new WebSocket(`${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws`);
      ws.onopen = () => {
        delay = 1000;
        ping = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000);
      };
      ws.onmessage = (e) => {
        const msg = JSON.parse(e.data);
        if (msg.type === "rides") onRides();
        if (msg.type === "presence") onPresence(msg.online);
      };
      ws.onclose = () => {
        clearInterval(ping);
        if (!stopped) timer = setTimeout(connect, (delay = Math.min(delay * 2, 30000)));
      };
    };
    connect();
    return () => {
      stopped = true;
      clearTimeout(timer);
      clearInterval(ping);
      ws?.close();
    };
  }, [onRides, onPresence]);
};
